/**
 * D6: Governance Config
 * Source: src/governance/pipeline/governanceConfigStore.ts
 */

import { USE_BACKEND, removeKey } from '../helpers';
import { safeStorageWrite } from '../../utils/storageQuota';
const GOVERNANCE_CONFIG_KEY = 'meester_djay_governance_config_v1';
export async function getGovernanceConfig(): Promise<Record<string, unknown> | null> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  try {
    const raw = localStorage.getItem(GOVERNANCE_CONFIG_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
export async function saveGovernanceConfig(config: Record<string, unknown>): Promise<boolean> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  return safeStorageWrite(GOVERNANCE_CONFIG_KEY, JSON.stringify(config));
}
export async function resetGovernanceConfig(): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  removeKey(GOVERNANCE_CONFIG_KEY);
}